import { inject, Injectable } from '@angular/core';
import { WmHttpService } from '../http/wm-http.service';
import { environment } from "@wms/app";
import { getValidJSON, isDefined } from '@wm/core';
import { BaseComponent } from '@wms/app/components';
import { SWAGGER_CONSTANTS } from '@wms/app/variables';
import { WebserviceService } from '../webservices/webservice.service';
import { getClonedObject, replace, triggerFn } from '@wms/app/core';
import { param } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService extends BaseComponent {

  httpService: any;
  webService: any;
  wmHttpService: any;
  TARGET = 'DATABASE';
  API_META: any = {
    testConnection: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testConnection",
      method: "POST"
    },
    testDatabase: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testDatabase",
      method: "POST"
    },
    testJarRequired: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/testDriver?dbType=:dbType",
      method: "GET"
    },
    read: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/read",
      method: "POST"
    },
    create: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/create",
      method: "POST"
    },
    readExistingDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/read",
      method: "POST"
    },
    reImportExistingDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources",
      method: "POST"
    },
    reImportCorruptDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources/update",
      method: "POST"
    },
    importDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/import",
      method: "POST"
    },
    reImportDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/sources/update",
      method: "POST"
    },
    exportDB: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/export",
      method: "POST"
    },
    loadModelInfo: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/loadModelInfo",
      method: "POST"
    },
    listTables: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/listTables",
      method: "POST"
    },
    getGeneratorTypes: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/configuration/:dbType",
      method: "GET"
    },

    /*DataModel related services*/
    getAllDataModels: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels",
      method: "GET"
    },
    getDataModel: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName?isdraft=:isdraft",
      method: "GET"
    },
    createDatabase: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database",
      method: "POST"
    },
    createService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services",
      method: "POST"
    },
    deleteService: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName",
      method: "DELETE"
    },
    saveDataModel: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/save",
      method: "POST"
    },
    applyDataModel: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/update",
      method: "POST"
    },
    revertDataModel: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/revert",
      method: "POST"
    },
    dataModelDiff: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/changes",
      method: "GET"
    },

    /*Entities related services*/

    getAllEntities: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables",
      method: "GET"
    },
    getEntity: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:tableName",
      "method": "GET"
    },
    createEntity: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables",
      method: "POST"
    },
    updateEntity: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName",
      method: "POST"
    },
    deleteEntity: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName",
      method: "DELETE"
    },

    /*Entity Columns related services*/
    addUniqueKey: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/constraints",
      method: "POST"
    },
    deleteUniqueKey: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/constraints/:uniquekeyname",
      method: "DELETE"
    },
    addPrimaryKey: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/primaryKey",
      method: "PUT"
    },
    addColumns: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns",
      method: "POST"
    },
    updateColumn: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns/:columnName?forceDataLoss=:forceDataLoss",
      method: "PUT"
    },
    deleteColumn: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/columns/:columnName",
      method: "DELETE"
    },

    /*Services related to relations*/

    addRelation: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations",
      method: "POST"
    },
    updateRelation: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations/:relationName",
      method: "PUT"
    },
    deleteRelation: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/tables/:entityName/relations/:relationName",
      method: "DELETE"
    },
    getTypesMap: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/configuration",
      method: "GET"
    },
    getSequences: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/sequences",
      method: "GET"
    },

    /*Queries Related services*/

    getAllQueries: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries",
      method: "GET"
    },
    getQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
      method: "GET"
    },
    createQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries",
      method: "POST"
    },
    updateQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
      method: "PUT"
    },
    queryNameUsage: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName/usages",
      method: "GET"
    },
    deleteQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName",
      method: "DELETE"
    },
    setQueryMetaData: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/queries/:queryName/metadata",
      method: "POST"
    },
    validateQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/query/validate",
      method: "POST"
    },
    getAllProcedures: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures",
      method: "GET"
    },
    getProcedure: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
      method: "GET"
    },
    createProcedure: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures",
      method: "POST"
    },
    updateProcedure: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
      method: "PUT"
    },
    deleteProcedure: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/datamodels/:dataModelName/procedures/:procedureName",
      method: "DELETE"
    },
    readTableData: {
      url: "/:service/:dataModelName/:entityName?page=:page&size=:size&:sort",
      method: "GET"
    },
    insertTableData: {
      url: "/:service/:dataModelName/:entityName",
      method: "POST"
    },
    insertMultiPartTableData: {
      url: "/:service/:dataModelName/:entityName",
      method: "POST",
      headers: {
        'Content-Type': undefined
      },
      // transformRequest: WM.identity TODO
    },
    updateTableData: {
      url: "/:service/:dataModelName/:entityName/:id",
      method: "PUT"
    },
    updateMultiPartTableData: {
      url: "/:service/:dataModelName/:entityName/:id",
      method: "POST",
      headers: {
        'Content-Type': undefined
      },
      // transformRequest: WM.identity
    },
    deleteTableData: {
      url: "/:service/:dataModelName/:entityName/:id",
      method: "DELETE"
    },
    updateCompositeTableData: {
      url: "/:service/:dataModelName/:entityName/composite-id?:id",
      method: "PUT"
    },
    periodUpdateCompositeTableData: {
      url: "/:service/:dataModelName/:entityName/composite-id/periods?:id",
      method: "PUT"
    },
    updateMultiPartCompositeTableData: {
      url: "/:service/:dataModelName/:entityName/composite-id?:id",
      method: "POST",
      headers: {
        'Content-Type': undefined
      },
      // transformRequest: WM.identity
    },
    deleteCompositeTableData: {
      url: "/:service/:dataModelName/:entityName/composite-id?:id",
      method: "DELETE"
    },
    periodDeleteCompositeTableData: {
      url: "/:service/:dataModelName/:entityName/composite-id/periods?:id",
      method: "DELETE"
    },
    countTableDataWithQuery: {
      url: "/:service/:dataModelName/:entityName/count",
      method: "POST",
      headers: {
        'Content-Type': "application/x-www-form-urlencoded"
      }
    },
    searchTableData: {
      url: "/:service/:dataModelName/:entityName/search?page=:page&size=:size&:sort",
      method: "POST"
    },
    searchTableDataWithQuery: {
      url: "/:service/:dataModelName/:entityName/filter?page=:page&size=:size&:sort",
      method: "POST",
      headers: {
        'Content-Type': "application/x-www-form-urlencoded"
      }
    },
    getDistinctDataByFields: {
      url: "/:service/:dataModelName/:entityName/aggregations?page=:page&size=:size&:sort",
      method: "POST"
    },
    exportTableData: {
      url: environment.SERVICES_BASE_PATH + "services/:dataModelName/:entityName/export?:sort",
      method: "POST"
    },
    readTableRelatedData: {
      url: "/:service/:dataModelName/:entityName/:id/:relatedFieldName?page=:page&size=:size&:sort",
      method: "GET"
    },
    executeNamedQuery: {
      url: "/:service/:dataModelName/queryExecutor/queries/:queryName?page=:page&size=:size&:queryParams",
      method: "GET"
    },
    executeCustomQuery: {
      url: "/:service/:dataModelName/queries/execute?page=:page&size=:size",
      method: "POST"
    },
    executeAggregateQuery: {
      url: environment.SERVICES_BASE_PATH + "services/:dataModelName/:entityName/aggregations?page=:page&size=:size&sort=:sort",
      method: "POST"
    },
    testRunQuery: {
      url: "/:service/:dataModelName/queries/test_run",
      method: "POST"
    },
    nativeTestRunQuery: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/queries/testrun",
      method: "POST",
      headers:{
        'content-Type': 'multipart/form-data',
      }
    },


    /*Procedure related properties*/
    executeNamedProcedure: {
      url: "/:service/:dataModelName/procedureExecutor/procedure/execute/:procedureName?page=:page&size=:size&:procedureParams",
      method: "GET"
    },
    testRunProcedure: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/procedures/testrun",
      method: "POST",
    },
    proceduresInDatabase: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:dataModelName/procedures",
      method: "GET"
    },

    /*Database connection properties*/
    getSampleDbConnectionProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/sample/connectionProps?sampleDbName=:sampleDbName",
      method: "GET"
    },
    getConnectionProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/properties",
      method: "GET"
    },
    updateConnectionProperties: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/properties",
      method: "PUT"
    },

    // read and update offline configuration
    updateOfflineConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/offline",
      method: "POST"
    },
    getOfflineConfig: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/database/services/:serviceId/offline",
      method: "GET"
    }
  };

  externalLinks: any = {
    CREATE_DESIGN_DATABASE: "https://www.wavemaker.com/learn/jump-start/jump-start-db-essentials/#create-database-from-designer",
    IMPORT_DATABASE: "https://www.wavemaker.com/learn/jump-start/jump-start-db-essentials/#import-database",
    CREATE_SCRIPT_DATBASE: "https://www.wavemaker.com/learn/jump-start/jump-start-db-essentials/#create-database-by-importing-script",
  }

  databaseNames: any[] = []
  constructor() {
    super();
    this.webService = inject(WebserviceService);
    this.httpService = inject(WmHttpService);
    this.wmHttpService = inject(WmHttpService);
    this.httpService.registerApiMeta(this.TARGET, this.API_META);
  }

  /**
 * @ngdoc function
 * @name wm.database.$DatabaseService#getAllEntities
 * @methodOf wm.database.$DatabaseService
 * @function
 *
 * @description
 * Method to get all the tables in the specified database.
 *
 * @param {object} params
 *                 Object containing name of the project & details of the database.
 * @param {function=} successCallback
 *                    Callback function to be triggered on success.
 * @param {function=} failureCallback
 *                    Callback function to be triggered on failure.
 */

  getAllEntities(params: any, successCallback: any, failureCallback: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getAllEntities",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      }
    }, successCallback, failureCallback) as Promise<any>);
  }
  reImportDB(data: any) {
    return (this.wmHttpService.execute({
      target: 'Database',
      action: 'reImportDB',
      data: data,
      pathParams: {
        projectID: data.projectID,
        serviceId: data.serviceId,
      },
      spinnerInfo: {
        showSpinner: false
      },
      toasterInfo: {
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, description: this.locale.MESSAGE_CODEGEN_RE_GENERATION_SUCCESS },
        'error': { title: this.locale.MESSAGE_ERROR_TITLE, description: this.locale.MESSAGE_ERROR_CODEGEN_DATABASE_DESC }
      }
    }) as Promise<any>);
  }

  /**
 * @ngdoc function
 * @name wm.database.$DatabaseService#getDataModel
 * @methodOf wm.database.$DatabaseService
 * @function
 *
 * @description
 * Method to get complete meta data(i.e., tables, columns, relations etc.) of the specified database.
 *
 * @param {object} params
 *                 Object containing name of the project and name of the datamodel.
 * @param {function=} successCallback
 *                    Callback function to be triggered on success.
 * @param {function=} failureCallback
 *                    Callback function to be triggered on failure.
 */
  getDataModel(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getDataModel",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        isdraft: params.isdraft
      }
    }) as Promise<any>);
  }

  /*
  * @ngdoc function
  * @name wm.database.$DatabaseService#executeCustomQuery
  * @methodOf wm.database.$DatabaseService
  * @function
  *
  * @description
  * Method to execute a custom query.
  *
  * @param {object} params
  *                 Object containing name of the project, name of the database and query to be executed.
  * @param {function=} successCallback
  *                    Callback function to be triggered on success.
  * @param {function=} failureCallback
  *                    Callback function to be triggered on failure.
  */

  executeCustomQuery(params: any, successCallback: any, failureCallback: any) {
    return this.initiateAction("executeCustomQuery", params, successCallback, failureCallback);
  }

  initiateAction(action: any, params: any, successCallback: any, failureCallback: any, noproxy?: any) {
    let param,
      val,
      config,
      connectionParams,
      urlParams,
      requestData,
      headers,
      httpDetails;

    config = this.API_META[action];
    headers = config && config.headers;
    requestData = params.data;

    urlParams = {
      projectID: params.projectID,
      service: isDefined(params.service) ? params.service : 'services',
      dataModelName: params.dataModelName,
      entityName: params.entityName,
      queryName: params.queryName,
      queryParams: params.queryParams,
      procedureName: params.procedureName,
      procedureParams: params.procedureParams,
      id: params.id,
      relatedFieldName: params.relatedFieldName,
      page: params.page,
      size: params.size,
      sort: params.sort
    };
    if (params.url && !noproxy) {

      /* Check for url parameters to replace the URL.
       * So the variable parameters in the URL will be replaced by the actual parameter values.*/
      if (urlParams) {
        for (param in urlParams) {
          if (urlParams.hasOwnProperty(param)) {
            val = urlParams[param];
            if (isDefined(val) && val !== null) {
              config.url = config.url.replace(new RegExp(":" + param, "g"), val);
            }
          }
        }
      }
      headers = headers || {};
      headers.skipSecurity = 'true';
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
      /*(!$rootScope.preferences['workspace.loadXDomainAppDataUsingProxy'] is added in endpointAddress to differentiate desktop from saas*/
      if (action === 'testRunQuery') {
        delete headers['Content-Type']
        httpDetails = {
          'endpointAddress': window.location.protocol + (!this.preferencesService.get('workspace.loadXDomainAppDataUsingProxy') ? ('//' + window.location.host) : '') + params.url + config.url,
          'method': config.method,
          'content-Type': 'multipart/form-data',
          'headers': headers
        };
        requestData.append(SWAGGER_CONSTANTS.WM_HTTP_JSON, new Blob([JSON.stringify(httpDetails)], {
          type: 'application/json'
        }));
        connectionParams = {
          'data': requestData,
          'headers': headers,
          'pathParams': {
            projectID: this.projectService.getProjectId()
          }
        };
      } else {
        connectionParams = {
          'data': {
            'endpointAddress': window.location.protocol + (!this.preferencesService.get('workspace.loadXDomainAppDataUsingProxy') ? ('//' + window.location.host) : '') + params.url + config.url,
            'method': config.method,
            'requestBody': JSON.stringify(requestData),
            'headers': headers
          },
          'pathParams': {
            projectID: this.projectService.getProjectId()
          }
        };
      }
      (this.webService.testRestService(connectionParams) as Promise<any>).then((response) => {
        let parsedData = getValidJSON(response.responseBody),
          errMsg,
          localeObject;
        if (parsedData) {
          if (parsedData.hasOwnProperty('result')) {
            triggerFn(successCallback, parsedData.result);
          } else if (parsedData.hasOwnProperty('error')) {
            triggerFn(failureCallback, (parsedData.error && parsedData.error.message) || parsedData.error);
          } else if (parsedData.hasOwnProperty('errorDetails')) {
            localeObject = this.locale;
            errMsg = getClonedObject(localeObject[parsedData.errorDetails.code]);
            triggerFn(failureCallback, replace(errMsg, parsedData.errorDetails.data) || parsedData.errorDetails);
          } else {
            triggerFn(successCallback, parsedData);
          }
        }
      }, failureCallback);
    }
  };

  getAllQueries(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getAllQueries",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      },
      spinnerInfo: {
        showSpinner: false,
      },
    }) as Promise<any>);
  }

  getAllProcedures(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getAllProcedures",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      },
      spinnerInfo: {
        showSpinner: false,
      },
    }) as Promise<any>);
  }

  getConnectionProperties(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getConnectionProperties",
      spinnerInfo: {
        showSpinner: false,
      },
      pathParams: {
        projectID: params.projectID,
        serviceId: params.dataModelName,
      }
    }) as Promise<any>);
  }

  testConnection(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "testConnection",
      pathParams: {
        projectID: params.projectID,
      },
      data: {
        username: params.username,
        password: params.password,
        url: params.url,
        driverClass: params.driverClass,
        dialect: params.dialect,
        metadataDialect: params.metadataDialect
      }
    }) as Promise<any>);
  }
  create(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "create",
      pathParams: {
        projectID: params.projectID,
      },
      data: {
        dataModel: params.dataModel,
        properties: {
          serviceId: params.serviceId,
          packageName: params.packageName,
          username: params.username,
          password: params.password,
          url: params.url,
          dbServerVersion:params.dbServerVersion,
          tableFilter: params.tableFilter,
          schemaName: params.schemaName,
          schemaFilter: params.schemaFilter,
          driverClass: params.driverClass,
          dialect: params.dialect,
          metadataDialect: params.metadataDialect,
          revengNamingStrategyClassName: params.revengNamingStrategyClassName,
          impersonateUser: !1,
          activeDirectoryDomain: params.activeDirectoryDomain,
          dbType: params.dbType,
          host: params.host,
          port: params.port,
          dbName: params.dbName,
          readOnly: params.readOnly
        }
      },
      spinnerInfo: {
        showSpinner: false,
      },
    }) as Promise<any>);
  }

  reImportExistingDB(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "reImportExistingDB",
      data: {
        dataModel: params.dataModel,
        properties: params.data
      },
      pathParams: {
        projectID: params.projectID,
        serviceId: params.serviceId
      }
    }) as Promise<any>);
  }

  getSampleDbConnectionProperties(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getSampleDbConnectionProperties",
      pathParams: {
        projectID: params.projectID,
        sampleDbName: params.sampleDbName,
      }
    }) as Promise<any>);
  }

  listTables(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "listTables",
      pathParams: {
        projectID: params.projectID,
      },
      spinnerInfo: {
        showSpinner: false,
      },
      data: params.data
    }) as Promise<any>);
  }

  getGeneratorTypes(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getGeneratorTypes",
      pathParams: {
        projectID: params.projectID,
        dbType: params.dbType
      },
      spinnerInfo: {
        showSpinner: false,
      },
    }) as Promise<any>);
  }

  read(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "read",
      data: {
        serviceId: params.serviceId,
        packageName: params.packageName,
        username: params.username,
        password: params.password,
        url: params.url,
        tableFilter: params.tableFilter,
        schemaName: params.schemaName,
        schemaFilter: params.schemaFilter,
        driverClass: params.driverClass,
        dialect: params.dialect,
        metadataDialect: params.metadataDialect,
        revengNamingStrategyClassName: params.revengNamingStrategyClassName,
        impersonateUser: !1,
        activeDirectoryDomain: params.activeDirectoryDomain,
        dbType: params.dbType,
        host: params.host,
        port: params.port,
        dbName: params.dbName,
        readOnly: params.readOnly
      },
      pathParams: {
        projectID: params.projectID
      },
      spinnerInfo: {
        showSpinner: false,
      }
    }) as Promise<any>);
  }

  readExistingDB(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "readExistingDB",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
        serviceId: params.serviceId
      }
    }) as Promise<any>);
  }
  updateConnectionProperties(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateConnectionProperties",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
        serviceId: params.dataModelName
      }
    }) as Promise<any>);
  }

  testJarRequired(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "testJarRequired",
      pathParams: {
        projectID: params.projectID,
        dbType: params.dbType
      },
      spinnerInfo: {
        showSpinner: false,
      }
    }) as Promise<any>);
  }

  exportDB(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "exportDB",
      data: params,
      pathParams: {
        projectID: params.projectID,
        serviceId: params.serviceId
      },
      spinnerInfo: {
        showSpinner: false,
      }
    }) as Promise<any>);
  }

  createDatabase(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "createDatabase",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
      }
    }) as Promise<any>);
  }

  createService(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "createService",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
      }
    }) as Promise<any>);
  }

  testDatabase(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "testDatabase",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
      }
    }) as Promise<any>);
  }
  deleteDataModel(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteService",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      }
    }) as Promise<any>);
  }

  getTypesMap(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getTypesMap",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      }
    }) as Promise<any>);
  }

  getQuery(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getQuery",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        queryName: params.queryName
      }
    }) as Promise<any>);
  }

  nativeTestRunQuery(params: any, successCallback: any, failureCallback: any) {
    (this.httpService.execute({
      target: "Database",
      action: "nativeTestRunQuery",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      }
    })as Promise<any>).then((response) =>{
      triggerFn(successCallback, response);
    }).catch((response) => triggerFn(failureCallback, response))

  }

  testRunQuery(params: any, successCallback: any, failureCallback: any) {
    this.API_META.testRunQuery.url = "/:service/:dataModelName/queries/test_run"
    return this.initiateAction("testRunQuery", params, successCallback, failureCallback);

  }

  createQuery(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "createQuery",
      data:params.data,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      }
    }) as Promise<any>);
  }

  deleteQuery(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteQuery",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        queryName: params.queryName
      }
    }) as Promise<any>);
  }

  updateQuery(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateQuery",
      data:params.data,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        queryName: params.queryName
      }
    }) as Promise<any>);
  }

  proceduresInDatabase(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "proceduresInDatabase",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      }
    }) as Promise<any>);
  }

  getProcedure(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getProcedure",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        procedureName: params.procedureName
      }
    }) as Promise<any>);
  }

  createProcedure(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "createProcedure",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      },
      returnTypeMetadata: params.returnTypeMetadata
    }) as Promise<any>);
  }

  updateProcedure(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateProcedure",
      data: params.data,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        procedureName: params.procedureName
      },
      returnTypeMetadata: params.returnTypeMetadata
    }) as Promise<any>);
  }

  deleteProcedure(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteProcedure",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        procedureName: params.procedureName
      },
    }) as Promise<any>);
  }

  validateProcedure(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "validateProcedure",
      data: params.queryDetails,
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
      },
    }) as Promise<any>);
  }

  testRunProcedure(params: any, successCallback: any, failureCallback: any) {
      let headers:any =  {}
        headers.skipSecurity = "true"
       let connectionParams = {
        target: "Database",
        action: "testRunProcedure",
        pathParams: params,
        headers:headers,
        data: params.data || "",
        config: {
            url: params.url
        }
    }
    return (this.httpService.execute(connectionParams)as Promise<any>).then((response) =>{
      triggerFn(successCallback, response);
    }).catch((response) => triggerFn(failureCallback, response));

  }

  getDataModelDiff(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "dataModelDiff",
      pathParams: {
        projectID: params.projectID,
        serviceId: params.dataModelName,
      },
    }) as Promise<any>);
  }

  addColumns(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "addColumns",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: params.entityName
      },
      data: params.data
    }) as Promise<any>);
  }

  updateColumn(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateColumn",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName),
        columnName: encodeURIComponent(params.columnName),
        forceDataLoss: params.forceDataLoss || !1
      },
      data: params.data
    }) as Promise<any>);
  }

  deleteColumn(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteColumn",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName),
        columnName: encodeURIComponent(params.columnName)
      },
    }) as Promise<any>);
  }

  addRelation(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "addRelation",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: params.entityName
      },
      data: params.data
    }) as Promise<any>);
  }
  updateRelation(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateRelation",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName),
        relationName: encodeURIComponent(params.relationName)
      },
      data: {
        cascadeEnabled: params.data.cascadeEnabled,
        cascadeOptions: params.data.cascadeOptions,
        fetchOptions: params.data.fetchOptions,
        parentFetchOptions: params.data.parentFetchOptions
    }    }) as Promise<any>);
  }

  deleteRelation(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteRelation",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName),
        relationName: encodeURIComponent(params.relationName)
      },
     }) as Promise<any>);
  }

  saveDataModel(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "saveDataModel",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
     }) as Promise<any>);
  }

  applyDataModel(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "applyDataModel",
      pathParams: {
        projectID: params.projectID,
        serviceId: params.dataModelName
      },
      data: params.data
     }) as Promise<any>);
  }

  revertDataModel(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "revertDataModel",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
      data: params.data
     }) as Promise<any>);
  }

  createEntity(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "createEntity",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
      data: params.data
     }) as Promise<any>);
  }

  updateEntity(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateEntity",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName)
      },
      data: params.data
     }) as Promise<any>);
  }

  deleteEntity(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteEntity",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName)
      },
     }) as Promise<any>);
  }

  addUniqueKey(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "addUniqueKey",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: params.entityName
      },
      data: params.data

     }) as Promise<any>);
  }

  deleteUniqueKey(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "deleteUniqueKey",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: encodeURIComponent(params.entityName),
        uniquekeyname: encodeURIComponent(params.uniquekeyname)
      },
     }) as Promise<any>);
  }


  addPrimaryKey(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "addPrimaryKey",
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName,
        entityName: params.entityName
      },
      data: params.data
     }) as Promise<any>);
  }

  getSequences(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getSequences",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
     }) as Promise<any>);
  }

  getOfflineConfig(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "getOfflineConfig",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
     }) as Promise<any>);
  }

  updateOfflineConfig(params: any) {
    return (this.httpService.execute({
      target: "Database",
      action: "updateOfflineConfig",
      spinnerInfo: {
        showSpinner: false
      },
      pathParams: {
        projectID: params.projectID,
        dataModelName: params.dataModelName
      },
      data: params.data
     }) as Promise<any>);
  }
}
